var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: { padding: "40px 0 40px 0", "background-color": "#2D2D2D" }
    },
    [
      _c(
        "el-col",
        { attrs: { span: 24 } },
        [
          _c("span", { staticClass: "title-bold" }, [_vm._v("HDD Renders")]),
          _vm._v(" "),
          _c("span", { staticClass: "paragraph" }, [
            _vm._v(
              "Take great pride in delivering the best quality architectural\n      renders"
            )
          ]),
          _vm._v(" "),
          _c("span", { staticClass: "paragraph" }, [
            _vm._v(
              "Our high-quality digital renders are used globally to assist with\n      creating visual representations of finished real estate\n      developments"
            )
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            {
              staticStyle: {
                display: "flex",
                "justify-content": "center",
                padding: "0 16px 16px 16px"
              },
              attrs: { span: 24 }
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "find-out-btn",
                  attrs: {
                    id: "homePageCreativeAdsPrestigePartner",
                    type: "primary"
                  },
                  on: { click: _vm.goToLink }
                },
                [_vm._v("Find out more\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-58c5a521", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c5a521","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/findOutMore.vue
// module id = null
// module chunks = 